import { CoinIcon, FreeTicketIcon, WaitAndFreeIcon } from "./Icons";
import { EpisodeAccessModel } from "@api/models";
import { sessionStore } from "@lib/sessionStore";
import { timeRemaining } from "@lib/utils";
import { useUserPoints } from "app/hooks";
import clsx from "clsx";
import { GLOBALS } from "config";
import Link from "next/link";
import { useSyncExternalStore } from "react";

/**
 * 有料作品の際に表示される購入種類のアイコン
 */
export function EpisodeIcon({
  access,
  waitAndFreeWaiting,
  showWaitAndFreeIcon,
  showReadButton,
  episodeId,
}: {
  access: EpisodeAccessModel;
  waitAndFreeWaiting: boolean;
  showWaitAndFreeIcon?: boolean;
  showReadButton?: boolean;
  episodeId?: string;
}) {
  const { hasAccess, accessType, timeRemainingInSeconds, price } = access;
  const { userPoints } = useUserPoints();
  const { sessionStatus } = useSyncExternalStore(
    sessionStore.subscribe,
    sessionStore.getSnapshot,
    sessionStore.getServerSnapshot,
  );

  let content;

  const disableFreeTicket: boolean =
    sessionStatus === "authenticated" &&
    (userPoints?.bonusValue === undefined || !(userPoints?.bonusValue > 0));

  if (hasAccess) {
    if (accessType === "purchased") {
      content = (
        <>
          {GLOBALS.IS_RENTAL && (
            <span className="series-eplist-item-access-text">
              レンタル中
              <br />
              閲覧期限
              <br />
              {timeRemaining(timeRemainingInSeconds)}
            </span>
          )}
          {!GLOBALS.IS_RENTAL && <span className="series-eplist-item-access-text">購入済</span>}
        </>
      );
    } else if (accessType === "waitAndFree") {
      content = (
        <span className="series-eplist-item-access-text">
          {GLOBALS.IS_RENTAL && (
            <>
              レンタル中
              <br />
            </>
          )}
          閲覧期限
          <br />
          {timeRemaining(timeRemainingInSeconds)}
        </span>
      );
    } else if (accessType === "trial" || accessType === "free") {
      content = <span className="series-eplist-item-access-text mode-free">無料</span>;
    }
  } else {
    if (accessType === "paidContent" || (accessType === "waitAndFree" && !showWaitAndFreeIcon)) {
      // 試し読みなしの有料
      content = (
        <>
          {price && (
            <div className="series-eplist-item-access-paid">
              {!access.isDisableBonus && (
                <span className="series-eplist-item-access-paid-item">
                  <FreeTicketIcon
                    size={18}
                    className={clsx(
                      "series-eplist-item-access-icon",
                      disableFreeTicket && "mode-disabled",
                    )}
                  />
                  <span>
                    1<span className="series-eplist-item-access-paid-unit-text">枚</span>
                  </span>
                </span>
              )}
              <span className="series-eplist-item-access-paid-item">
                <CoinIcon size={16} className="" />
                {price}
              </span>
            </div>
          )}
        </>
      );
    } else if (accessType === "waitAndFree") {
      content = (
        <>
          <WaitAndFreeIcon
            size={24}
            className={
              "series-eplist-item-access-icon" + (waitAndFreeWaiting ? " mode-disabled" : "")
            }
          />
          {!access.isDisableBonus && (
            <FreeTicketIcon
              size={24}
              className={clsx(
                "series-eplist-item-access-icon",
                disableFreeTicket && "mode-disabled",
              )}
            />
          )}
        </>
      );
    }
  }
  if (accessType === "memberOnlyFree") {
    content = <span className="series-eplist-item-access-text mode-free">今なら無料</span>;
  }
  return (
    <div>
      {content}
      {showReadButton &&
        access.hasAccess &&
        accessType !== "trial" &&
        accessType !== "free" &&
        accessType !== "memberOnlyFree" && (
          <Link className="series-eplist-item-access-btn" href={`/episodes/${episodeId}`}>
            読む
          </Link>
        )}
    </div>
  );
}
